<template>
  <div class="staff-component">
    <v-row class="align-center">
      <v-col cols="4">
        <div class="d-flex align-center">
          <div class="avatars d-flex flex-column">
            <avatar :user="getEmployee(firstEmployee)"/>
          </div>
          <div class="select-section">
            <v-select
              v-model="firstEmployee"
              @change="setStaff"
              :items="workspace.users"
              item-text="name"
              item-value="id"
              hide-details="auto"
              item-color="#ff9100"
              class="select"
              solo
              height="42"
              full-width
            />
          </div>
        </div>
      </v-col>
      <v-col cols="5"></v-col>
      <v-col cols="3">
        <div class="staff-radio">
          <v-radio-group v-model="shiftTime" @change="setStaff">
            <v-radio
              value="full"
              name="shiftTimes"
              label="Полная смена"
              class="radio-button"
              :ripple="false"
            />
            <v-radio
              value="half"
              name="shiftTimes"
              label="Пол смены"
              class="radio-button"
              :ripple="false"
            />
          </v-radio-group>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="shiftTime === 'half'" class="align-center mt-1">
      <v-col cols="4">
        <div class="d-flex align-center">
          <div class="avatars d-flex flex-column">
            <avatar :user="getEmployee(secondEmployee)"/>
          </div>
          <div class="select-section">
            <v-select
              v-model="secondEmployee"
              @change="setStaff"
              :items="workspace.users"
              item-text="name"
              item-value="id"
              hide-details="auto"
              item-color="#ff9100"
              class="select"
              solo
            />
          </div>
        </div>
      </v-col>
      <v-col cols="5"></v-col>
      <v-col cols="3">
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { DateTime } from 'luxon'
  import IconSushifox from '@/components/icons/IconSushifox'
  import Avatar from '@/components/administrator/work-shift/staff/Avatar'

  export default {
    name: 'Staff',
    components: { Avatar, IconSushifox },
    props: {
      workspace: {
        type: Object,
        default: () => {},
      },
      value: {
        type: Array,
        default: () => ([]),
      },
    },
    data () {
      return {
        firstEmployee: null,
        firstTimeFrom: null,
        firstTimeTo: null,

        secondEmployee: null,
        secondTimeFrom: null,
        secondTimeTo: null,

        shiftTime: 'full',
        currentDate: DateTime.local().toFormat('y-MM-d'),
      }
    },
    watch: {
      value () {
        if (JSON.stringify(this.value) !== JSON.stringify(this.getItems)) {
          if (!this.value) return
          this.value.forEach(item => {
            if (item.shiftTime === 'full') {
              this.firstEmployee = item.id
              this.shiftTime = 'full'
            }
            if (item.shiftTime !== 'full') {
              this.shiftTime = 'half'
            }
            if (item.shiftTime === 'first') {
              this.firstEmployee = item.id
            }
            if (item.shiftTime === 'second') {
              this.secondEmployee = item.id
            }
          })
        }
        this.setStaff()
      },
    },
    computed: {
      getItems () {
        let items = []
        if (this.shiftTime === 'half') {
          items = [
            {
              workSpaceId: this.workspace.workSpaceId,
              shiftTime: 'first',
              userId: this.firstEmployee,
              date: this.currentDate,
            },
          ]
          if (this.secondEmployee) {
            items.push({
              workSpaceId: this.workspace.workSpaceId,
              shiftTime: 'second',
              userId: this.secondEmployee,
              date: this.currentDate,
            })
          }
        } else if (this.shiftTime === 'full') {
          items = [
            {
              workSpaceId: this.workspace.workSpaceId,
              shiftTime: 'full',
              userId: this.firstEmployee,
              date: this.currentDate,
            },
          ]
        }
        return items
      },
    },
    methods: {
      hasAvatar (employeeId) {
        const employee = this.workspace.users.find(user => user.id === employeeId)
        return employee && employee.image ? !!employee.image : false
      },
      getAvatar (employeeId) {
        const employee = this.workspace.users.find(user => user.id === employeeId)
        return employee ? employee.image : null
      },
      setStaff () {
        console.log('set staff', this.getItems)
        this.$emit('input', this.getItems)
      },
      getEmployee (employeeId) {
        return this.workspace.users.find(user => user.id === employeeId)
      },
    },
  }
</script>

<style lang="less" scoped>
  .staff-component {
    padding: 0 12px;
    background: #F1F3F6;
    border-radius: 4px;
    margin-bottom: 10px;

    @media (max-width: @sm) {
      flex-wrap: wrap;
      margin-bottom: 30px;
    }

    .select-section {
      //flex: 1 1 auto;
      display: flex;
      align-items: center;
      .select {
        //margin-bottom: 12px;
      }

      ::v-deep {
        .v-input {
          font-size: 14px;
        }
        .v-text-field.v-text-field--solo {
          .v-input__control {
            min-height: 42px;
          }
          .v-input__slot {
            height: 42px;
            min-height: 42px;
          }
        }
      }
    }

    .staff-radio {
      display: flex;
      align-items: center;
      margin-left: 24px;

      ::v-deep {
        .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
          margin-bottom: 0 !important;
        }

        .v-input--radio-group--column .v-input--radio-group__input {
          display: flex !important;
          flex-direction: row !important;
          align-items: center;
        }
      }
    }

    .avatars {
      .avatar {
        width: 50px;
        height: 50px;
        border: 4px solid #fff;
        background-color: #00000008;
        border-radius: 50%;
        margin-right: 24px;
        flex-shrink: 0;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #cfcfcf;
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
        &:nth-child(2) {
          margin-top: 10px;
        }
      }
    }

    .radio-button {
      &:first-child {
        margin-right: 24px;
      }

      /*::v-deep {
        .v-input--selection-controls__input {
          width: 60px;
          height: 60px;
        }

        .v-label {
          font-size: 18px !important;
          color: #000000;
          max-width: 60px;
          font-weight: 400 !important;
        }

        i {
          width: 60px;
          height: 60px;

          &:before {
            font-size: 40px;
            color: #a5a5a5;
          }
          @media(max-width: @sm) {
            width: 30px;
            height: 30px;

            &:before {
              font-size: 24px;
            }
          }
        }
        @media(max-width: @sm) {
          .v-input--selection-controls__input {
            width: 30px;
            height: 30px;
          }
          .v-label {
            font-size: 14px !important;
            max-width: 100px;
          }
        }

      }*/
    }

    .select {
      .v-input__slot {
        height: 60px;
      }
    }
  }
</style>
